import { render, staticRenderFns } from "./scanPage.vue?vue&type=template&id=49708da5&scoped=true"
import script from "./scanPage.vue?vue&type=script&lang=js"
export * from "./scanPage.vue?vue&type=script&lang=js"
import style0 from "./scanPage.vue?vue&type=style&index=0&id=49708da5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49708da5",
  null
  
)

export default component.exports